"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ripple_keypairs_1 = require("ripple-keypairs");
var Account_1 = __importDefault(require("../schema/Account"));
var familySeed = function (options) {
    if (options === void 0) { options = {}; }
    options = Object.assign(options, {
        algorithm: options.algorithm === "ed25519" ? "ed25519" : "secp256k1"
    });
    var Familyseed = (0, ripple_keypairs_1.generateSeed)(options);
    var Keypair = (0, ripple_keypairs_1.deriveKeypair)(Familyseed);
    var Address = (0, ripple_keypairs_1.deriveAddress)(Keypair.publicKey);
    return new Account_1.default({
        algorithm: options.algorithm,
        address: Address,
        familySeed: Familyseed,
        keypair: Keypair
    });
};
exports.default = familySeed;
